import React from "react";

export default function ArrowDown(props) {
  const { size = 16 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      {...props}
    >
      <path fill="currentColor" d="M4.659 11.833h30.682L20 32.167z"></path>
    </svg>
  );
}
